import React, { useEffect, useState } from 'react';
import { Table, DatePicker, Pagination } from 'antd';
import { authAxiosWithBearer, baseURL } from '../../../baseURL';
import { AiFillEdit, AiFillEye, AiOutlineSearch } from 'react-icons/ai';
import { Link, useNavigate } from 'react-router-dom';
import { formatDateTime } from '../../../Components/formatDateTime';
import { connect } from 'react-redux';
import LoadingSpinner from '../../../Components/LoadingSpinner';
import DateRangeFiltering from '../../../Components/DateRangeFiltering';

const WorkorderList = ({user}) => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowsId,setSelectedRowsId] = useState([])

  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await authAxiosWithBearer.get(`${baseURL}/inventory/api/workorders-list/`, {
          params: {
            page: currentPage,
            start_date: startDate,
            end_date: endDate,     
            search: searchText    
          },
        });
  
        const { results, count } = response.data;
  
        setTotalItems(count);
        setData(results);
      } catch (error) {
        console.log(error);
      }
      finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [startDate, endDate, currentPage, searchText]);


  
  const dataSource = data?.flatMap((data,index) =>({
    key:index,
    id:data?.id,
    wo_no: data?.wo_no,
    wo_by_text: data?.wo_by_text,
    wo_at: data?.wo_at,
    pr_no_list: data?.pr_no_list.join(' , '),
  }))



  const handleSearch = (value) => {
    setSearchText(value);
  };


  const columns = [
    {
      title: 'SN',
      key: 'key',
      render: (text, record, index) => {
        return (currentPage - 1) * 10 + index + 1;
      },
    },
    {
      title: 'WO NO',
      dataIndex: 'wo_no',
      key: '1',
    },
    {
        title: 'PR NO',
        dataIndex: 'pr_no_list',
        key: '2',
    },
    {
      title: 'WO DATE',
      dataIndex: 'wo_at',
      key: '3',
      render: (wo_at) => {
        const formattedDateTime = formatDateTime(wo_at);
        return <span>{formattedDateTime}</span>;
      },
    },
    {
      title: 'WO BY',
      dataIndex: 'wo_by_text',
      key: '4',
      // responsive: ['md']
    },
    {
        title: 'ACTIONS',
        dataIndex: 'actions',
        render: (_, record) => (
          <div className='flex gap-2'>
            {user?.menu_permissions?.includes("3.10.2") && (
              <button onClick={() => navigate(`/workorder-details/${record.id}/`)} className='rounded'>
                <AiFillEye className='text-[#6969f5] text-xl' />
              </button>
            )}
            {user?.menu_permissions?.includes("3.10.3") && (
              <button onClick={() => navigate(`/workorder-update/${record.id}/`)} className='rounded'>
                <AiFillEdit className='text-[#6F6F7E] text-xl' />
              </button>
            )}
          </div>
        ),
      },
  ];


  const handlePaginationChange = (page) => {
    setCurrentPage(page);
  };

  const handleGoToGRNPage = () => {
    navigate(`/workorder-to-grn`, { state: { selectedIds: selectedRowsId } });
  };


  return (
    <div className='container-fluid grid grid-cols-1 mx-1'>
      <div className='page-header mb-2 px-1'>
        <div className="flex justify-between pt-5">
          <div className='page-title my-auto md:ml-5'>
            <h1 className='uppercase'>WORKORDER LIST</h1>
          </div>     

          <div className='page-search-and-add-new-button md:flex my-auto md:mr-5'>
            <div className='page-date-range my-auto hidden md:flex'>
                <DateRangeFiltering setEndDate={setEndDate} endDate={endDate} setStartDate={setStartDate} startDate={startDate} />
            </div>
            
            <div className='page-search ml-2 hidden md:block'>
              <div className='relative'>
                <input
                  className='page-search-input w-[200px] md:w-[214px] appearance-none focus:outline-none focus:bg-white focus:border-[#F35B5B]'
                  type='text'
                  name='search'
                  required
                  onChange={(e) => handleSearch(e.target.value)}
                  placeholder='Search here'
                />
                <div className='text-xl absolute top-[5px] right-3'>
                  <button className='page-search-button' type='submit'>
                    <AiOutlineSearch className='text-[#fff] mx-auto' />
                  </button>
                </div>
              </div>
            </div>
            
            {user?.menu_permissions?.includes("3.9.1") && (
            <div className="add-new-button px-2 ml-1">
                  <Link to={`/pr-to-workorder`}>Add WO</Link>
            </div>
            )}
          </div>

        </div>

        <div className='page-search md:hidden mt-4'>
            <div className='relative'>
              <input
                className='page-search-input w-[85%] md:w-[214px] appearance-none focus:outline-none focus:bg-white focus:border-[#F35B5B]'
                type='text'
                name='search'
                required
                onChange={(e) => handleSearch(e.target.value)}
                placeholder='Search here'
              />
              <div className='text-xl absolute top-[-5px] right-0'>
                <button className='page-search-button p-[17px] px-6' type='submit'>
                  <AiOutlineSearch className='text-[#fff] mt-[-10px] mx-[-10px]' />
                </button>
              </div>
            </div>
        </div>

        <div className='page-header py-4 md:hidden'>
            <DateRangeFiltering setEndDate={setEndDate} endDate={endDate} setStartDate={setStartDate} startDate={startDate} />
        </div>
      </div>

      {user?.menu_permissions?.includes("3.11.1") && (
      <div className="workorder-button mb-2">
            <button 
            className='text-[#F35B5B] border border-[#F35B5B] p-1 font-semibold hover:bg-[#F35B5B] hover:text-[#fff]' 
            onClick={handleGoToGRNPage}
            >GRN</button>
      </div>
      )}

      <div className='shadow-lg pb-3 overflow-x-auto'>
      {isLoading ? (
        <p><LoadingSpinner /></p>
      ) : (
        <>
        <Table 
            columns={columns}
            dataSource={dataSource} 
            pagination={false}
            rowSelection={{
              selectedRowKeys: selectedRows,
              onChange: (selectedRowKeys) => {
                setSelectedRows(selectedRowKeys);
                const selectedIds = selectedRowKeys.map((key) => {
                  const selectedRow = dataSource.find((row) => row.key === key);
                  return selectedRow ? { id: selectedRow.id, wo_no: selectedRow.wo_no } : null;
                });
                setSelectedRowsId(selectedIds);
              },
              // hideSelectAll: filteredData?.some((row) => row.is_workorder_status === true),
              getCheckboxProps: (record) => ({
                disabled: record.is_workorder_status === true,
              }),
            }}
        />
        <div className='my-5'>
          <Pagination
          current={currentPage}
          total={totalItems}
          pageSize={10}
          showSizeChanger={false}
          onChange={handlePaginationChange}
        />
      </div>
      </>
      )}
      </div>
    </div>
  );
};



const mapStateToProps = (state) => ({
    user: state.auth.user,
  });
  
  export default connect(mapStateToProps)(WorkorderList);
